<div class="a-loading-indicator {{ modifier && 'a-loading-indicator--' + modifier || modifier }}"
	 data-t-name="LoadingIndicator"
	 [attr.data-t-decorator]="decorator">
	<div class="a-loading-indicator__one"></div>
	<div class="a-loading-indicator__two"></div>
	<div class="a-loading-indicator__three"></div>
</div>
